import { RemoteAgentConnection, Emitter, PersistentConnectionEvent } from './interfaces';

export class RemoteAgentConnectionImpl implements RemoteAgentConnection {

    protected readonly onDidStateChangeEmitter = new Emitter<PersistentConnectionEvent>();
    readonly onDidStateChange = this.onDidStateChangeEmitter.event;

    handleStateChange(event: PersistentConnectionEvent): void {
        this.onDidStateChangeEmitter.fire(event);
    }
}
